package org.multiplatform.kotfolio.pages.listing

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.multiplatform.kotfolio.components.AppearanceAwareImage
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.styles.UnderLineLinkVariant
import org.multiplatform.kotfolio.util.JetpackCompose
import org.multiplatform.kotfolio.util.Resources

@Page("label_cropping")
@Composable
fun LabelCropping() {
    BlogLayout(
        PageProperties(
            "Label Cropping - Label Cutter for Thermal & A4",
            ""
        ),
        BlogProperties("Label Cropping", "Amazon, Messo, Flipkart")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "sellerbox.in",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            SpanText(
                text = "Advantage",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sort by SKU",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Drag and Drop SKU",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Upload multiple Shipping Labels",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Check Preview Before Download",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Check your orders, profit, payments, and labels",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Label Cropping",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Link(
                            variant = UnderLineLinkVariant,
                            path = "https://www.sellerbox.in/label-sort-crop/flipkart",
                            text = "Flipkart Label Cropping - https://www.sellerbox.in/label-sort-crop/flipkart",
                            modifier = Modifier.margin(right = 4.px).fontSize(FontSize.Medium)
                                .textDecorationLine(TextDecorationLine.None)
                                .color(Resources.Colors.FOOTER_COLOR_LIGHT)
                        )
                        AppearanceAwareImage(
                            src = Resources.Images.NAVIGATION_ARROW
                        )
                    }
                }


                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Link(
                            variant = UnderLineLinkVariant,
                            path = "https://www.sellerbox.in/label-sort-crop/amazon",
                            text = "Amazon Label Cropping - https://www.sellerbox.in/label-sort-crop/amazon",
                            modifier = Modifier.margin(right = 4.px).fontSize(FontSize.Medium)
                                .textDecorationLine(TextDecorationLine.None)
                                .color(Resources.Colors.FOOTER_COLOR_LIGHT)
                        )
                        AppearanceAwareImage(
                            src = Resources.Images.NAVIGATION_ARROW
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Link(
                            variant = UnderLineLinkVariant,
                            path = "https://www.sellerbox.in/label-sort-crop/meesho",
                            text = "Messo Label Cropping - https://www.sellerbox.in/label-sort-crop/meesho",
                            modifier = Modifier.margin(right = 4.px).fontSize(FontSize.Medium)
                                .textDecorationLine(TextDecorationLine.None)
                                .color(Resources.Colors.FOOTER_COLOR_LIGHT)
                        )
                        AppearanceAwareImage(
                            src = Resources.Images.NAVIGATION_ARROW
                        )
                    }
                }
            }

            WebImage(
                src = Resources.Images.SELLER_BOX_1,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "SELLERBOX"
            )

            WebImage(
                src = Resources.Images.SELLER_BOX_2,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "SELLERBOX"
            )
        }
    }
}